import $ from 'jquery';
import { scrollToId } from './scrollTo';

const $jsPagination = $('.js-pagination'),
	DISABLED_CLASS = 'pagination__btn--disabled',
	$paginationBtnNext = $jsPagination.find('.pagination__btn--next'),
	$paginationBtnPrev = $jsPagination.find('.pagination__btn--prev'),
	$paginationInput = $jsPagination.find('.pagination__input'),
	$paginationTotal = $jsPagination.find('.pagination__total'),
	$paginationLabel = $jsPagination.find('label[for=pagination]');

export function init(scrollTargetId, setPageCallback) {
	$paginationBtnNext.on('click', function (event) {
		event.preventDefault();

		this.blur(); // unhighlight arrow btn
		setPage(getCurrentPage() + 1);
	});

	$paginationBtnPrev.on('click', function (event) {
		event.preventDefault();

		this.blur(); // unhighlight arrow btn
		setPage(getCurrentPage() - 1);
	});

	$paginationInput.on('input', function () {
		this.value = this.value.replace(/[^0-9]/g, '');
	});

	$paginationInput.on('change', function (event) {
		this.blur();
		setPage(event.target.value);
	});

	function setPage(page) {
		// clamp value into interval [1, totalPages]
		page = Math.max(Math.min(page, getTotalPages()), 1);

		setPageCallback(page);

		scrollToId(scrollTargetId);
	}
}

export function getCurrentPage() {
	const num = parseInt($paginationInput.val());
	return isNaN(num) ? 1 : num;
}

export function getTotalPages() {
	const num = parseInt($paginationTotal.text());
	return isNaN(num) ? 1 : num;
}

export function update(current, total) {
	// pagination text, e.g. "Page 1 of 10"
	setPaginationText(current, total);

	// toggle next button if necessary
	const isNextDisabled = $paginationBtnNext.hasClass(DISABLED_CLASS);
	if (!isNextDisabled && current === total) {
		disableButton($paginationBtnNext);
	} else if (isNextDisabled && current < total) {
		enableButton($paginationBtnNext);
	}

	// toggle prev button if necessary
	const isPrevDisabled = $paginationBtnPrev.hasClass(DISABLED_CLASS);
	if (!isPrevDisabled && current === 1) {
		disableButton($paginationBtnPrev);
	} else if (isPrevDisabled && current > 1) {
		enableButton($paginationBtnPrev);
	}

	function setPaginationText(current, total) {
		$paginationInput.val(current);
		$paginationInput.attr('value', current);
		$paginationTotal.text(total);

		let currentPageLabel = $paginationLabel.text();
		currentPageLabel = currentPageLabel.replace(/(.+) \d+ (.+) \d+/g, `$1 ${current} $2 ${total}`);
		$paginationLabel.text(currentPageLabel);
	}

	function disableButton(button) {
		button.addClass(DISABLED_CLASS);
		button.attr('aria-disabled', true);
	}

	function enableButton(button) {
		button.removeClass(DISABLED_CLASS);
		button.attr('aria-disabled', false);
	}
}

export function show() {
	$jsPagination.removeClass('u-hide');
}

export function hide() {
	$jsPagination.addClass('u-hide');
}
